<template>
  <div class="home-view">
    <h2 class="title">WELCOME</h2>

    <p class="intro-text">
      深圳量德信息技术有限公司成立于2022年，是一家从事软件开发、软件外包、系统集成、技术咨询、技术交流的高新技术企业，
      <span class="highlight">为客户提供一站式的整体系统集成解决方案，服务行业客户包含互联网、工厂、电商、医疗等客户</span>，
      自创办以来，在上位机开发、人工智能系统开发、 物联网开发、互联网开发、微信小程序、APP开发等服务于广大客户。
      <span class="highlight">目前公司正处于高速发展扩张阶段，致力于技术创新、更快、更好、更高的标准服务于广大客户。</span>
      <br />
<span class="highlight">
  系统平台网址：
  <a href="http://139.9.5.118:9010" target="_blank" rel="noopener noreferrer">
    http://139.9.5.118:9010
  </a>
</span>
    </p>

    <div class="image-grid">
      <img :src="img1" alt="图片1" />
      <img :src="img2" alt="图片2" />
      <img :src="img3" alt="图片3" />
      <img :src="img4" alt="图片4" />
    </div>
  </div>
</template>

<script setup>
const img1 = new URL('@/assets/home-hero.png', import.meta.url).href
const img2 = new URL('@/assets/myteam.png', import.meta.url).href
const img3 = new URL('@/assets/project.png', import.meta.url).href
const img4 = new URL('@/assets/liucheng.png', import.meta.url).href
</script>

<style scoped>
.home-view {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  text-align: center;
}

.title {
  font-size: 32px;
  margin-bottom: 20px;
  letter-spacing: 5px;
}

.intro-text {
  font-size: 16px;
  text-align: justify;
  line-height: 1.8;
  margin-bottom: 40px;
}

.highlight {
  color: #0055ff;
  font-weight: bold;
}

/* 竖直排列图片 */
.image-grid {
  display: flex;
  flex-direction: column; /* 竖直排列 */
  gap: 20px;
  align-items: center; /* 横向居中 */
}

.image-grid img {
  width: 90%;       /* 宽度占父容器80% */
  max-width: 850px; /* 最大宽度限制 */
  height: auto;     /* 高度自适应，保持比例 */
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
</style>
